import styled from "styled-components";

export const StartupWrapper = styled.div`
  height: 100vh;
  background: var(--bg-color, #f3f3f3);
  color: var(--text-color, #333);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .ant-spin-dot-item {
    background-color: var(--primary-color, #d91e49) !important;
  }
`;
export const StartupCard = styled.div`
  flex-basis: 538px;
  background: var(--bg-color-secondary, #ffffff);
  border: 1px solid var(--border-color-secondary, transparent);
  border-radius: 8px;
  padding: 24px;
  @media (max-width: 768px) {
    padding: 100px 20px;
  }
`;
